module.exports = __webpack_public_path__ + "img/instructions-3.3431c3bd.png";